<script setup>
import { computed } from "vue";

const props = defineProps({
  height: {
    type: String,
    required: true,
  },
});

const contentStyle = computed(() => ({ height: props.height }));
</script>

<template>
  <div class="modal-tab-content" :style="contentStyle">
    <slot />
  </div>
</template>

<style scoped>
.modal-tab-content {
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
